import type {
    ComponentStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry
} from '../../types'
import {rotationHeuristics} from './heuristicsDefinitions'
import {createAdaptiveHeuristic} from '../common'

export const createPlugin = ({stages}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const handleRotation = (componentStageData: ComponentStageData) => {
        const heuristicToApply = rotationHeuristics.find(({predicate}) => predicate(componentStageData))

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)

        return {
            appliedHeuristics: [heuristicToApply.heuristicCode]
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.POST_PROCESS, createAdaptiveHeuristic(handleRotation))
    }

    const name = 'cancelRotation'
    return {register, name}
}
